<template>
  <!-- button area (right side of question card) -->
  <div class="">

      <div v-if="question.question_type == 'text_attachment'" >
        <b-field>
              <b-upload v-model="newFiles"
                  @input="uploadFiles()"
                  multiple
                  drag-drop>
                  <section class="upload-field" ref="uploadBox">
                      <div class="content has-text-centered" >
                        <span class="icon">
                          <i class="fas fa-cloud-upload-alt"></i>

                        </span>

                          <p>Upload bijlage</p>
                      </div>
                  </section>
              </b-upload>
          </b-field>
          <!-- <div class="tags">
            <span v-for="(file, index) in uploads"
                :key="index"
                class="tag is-primary" >
                {{file.name}}
                <button class="delete is-small"
                    type="button"
                    @click="deleteDropFile(index)">
                </button>
            </span>
          </div> -->
      </div>

      <!-- <div class="global-question-icon question-options-wrapper"> -->
        <!-- <i class="fas fa-comment-dots"></i> -->

      <!-- </div> -->

      <!-- <div class="buttons has-addons">
        <span class="button comment-button-combined is-rounded" @click="toggleComment()">
          <span class="global-question-icon icon is-medium">
            <i class="fas fa-comment-dots"></i>
            <Icon type="md-chatbubbles" />
          </span>
          <span class="comment-button is-size-8"></span>
        </span>
        <span class="button is-light is-rounded">
          <span class="global-question-icon icon is-medium">
            <i class="fas fa-cloud-upload-alt"></i>
            <Icon type="md-attach" />

          </span>
          <span class="comment-button is-size-8">Upload</span>
        </span>
      </div> -->
      <!-- <a class="button is-light is-rounded">
        <span class="global-question-icon icon is-medium">
          <i class="fas fa-comment-dots"></i>
        </span>
        <span class="comment-button is-size-8">Opmerking</span>
      </a> -->

  </div>
</template>

<script>
export default {
  inject: ['question', 'comment', 'uploads'],
  data () {
    return {
      crow: this.$store.getters.getCrow,
      newFiles: [],
      // uploadedFiles: [],
      survey_id: this.$store.getters.getSurvey._id.$oid,
      loading: false
    }
  },
  methods: {
    toggleComment () {

      if ((this.question.comment_value === '') && this.comment.showComment) {
        this.comment.showComment = false
        // this.questionIsFocussed = true
      } else if (!this.comment.showComment) {
        this.comment.showComment = !this.comment.showComment
        this.comment.questionIsFocussed = true
      } else {
        this.comment.questionIsFocussed = !this.comment.questionIsFocussed
      }
    },
    // Take all uploads and send them to the uploads API
    // Creates an object with all uploads per question_id
    // @TODO function should be moved to Store
    uploadFiles () {
        const loading = this.$loading.open()
      // initiate FormData object to be send to API
        let formData = new FormData()
        formData.append('token', this.$store.getters.getToken)
        formData.append('id', this.survey_id)
        formData.append('activity_id', this.question.activity_id.$oid)
        formData.append('question_id', this.question._id.$oid)

        // Check filesize of all uploads and add them to formData object
        this.newFiles.forEach((file) => {
          if (this.checkFileSize(file, 10000000)) {
            formData.append('file_' + file.name, file)
          } else {
            // console.log('File ' + file.name + ' too big');
          }
        })

        // send uploads to API
        this.sendUploadedFiles('upload_question_attachment', formData, () => {
          // add uploaded files to separate array.
          this.newFiles.forEach((file) =>{
            this.uploads.push(file)
            this.newFiles = []
          })
          loading.close()

        })

    },
    // Check the filesize of an upload
    // Pass an array of files into this function
    checkFileSize (file, limit) {
      let result = false
      if (file.size < limit) result = true
      return result
    },
    // send uploaded files to API
    // @TODO move this function to store
    sendUploadedFiles (action, data, callback) {      
      this.$http.post(process.env.EMET_API_URL + '/survey/' + action, data, {emulateJSON: true})
      .then(function (response) {
        // console.log(response);
        if (response.data.status) {
          console.log('Upload completed');
          callback()
        }
      }, function (response) {

      })
    }
    // syncUploadsToStore () {
    //   let existingUploads = this.$store.getters.getUploads

    //   // remove all uploads from this specific question
    //   let u = existingUploads.length
    //   while (u--) {
    //     if (existingUploads[u].activity_id === this.question.activity_id.$oid && existingUploads[u].question_id === this.question._id.$oid) {
    //         existingUploads.splice(u, 1);
    //     }
    //   }

    //   // add current files to uploads array in store
    //   for (var i = 0, len = this.files.length; i < len; i++) {
    //     let newUpload = {}
    //     if (this.question.activity_id) newUpload.activity_id = this.question.activity_id.$oid
    //     if (this.question._id) newUpload.question_id = this.question._id.$oid

    //     newUpload.file = this.files[i]
    //     console.log(newUpload);

    //     existingUploads.push(newUpload)
    //   }

    //   this.$store.commit('setUploads', existingUploads)
    // }
  }
}
</script>

<style scoped>

.upload-field {
  padding: 30px 20px;
  height: 110px;
}

  .comment-button {
    margin-top: 20px;
    /* margin-right: 20px; */
    float: right;
  }

  .comment-button-combined {
    background-color: #eeeeee;
    border-color: #eeeeee;
  }

  .comment-button-combined:hover {
    background-color: #e6e5e5;
    border-color: #e6e5e5;
  }

  .attach-icon {
    font-size: 40px;
  }

  .question-options-wrapper {
    bottom: 0px;
  }

  /* .comment-button:hover {
    border: 1px solid #eeeeee;
    background-color: #eeeeee;
    border-radius: 5px;
  } */


  /* .upload-section {
    margin-bottom: 20px;
  } */

  /* .upload-box {
    width: 150px;
  } */

</style>



// WEBPACK FOOTER //
// src/components/elements/QuestionOptions.vue